import React from 'react';
import { useNavigate } from "react-router-dom";
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import LanguageSelect from './LanguageSelect';
import footerLang from '../../../data/lang/footer.lang';
import { useTags } from '../../../hooks/useTags';
import { useGetLanguageApp } from '../../../stores/app.store';
import { Languages } from '../../../enums/languages';
import style from '../../../styles/components/layout.module.css';


const Header = () => {

  const navigate = useNavigate();

  const curLang = useGetLanguageApp();
  const { projectConfigState } = useProjectConfigContext();
  const cityNameHeb = projectConfigState.hebName;
  const cityNameEng = projectConfigState.engName;
  const cityName = curLang === Languages.English ? cityNameEng : cityNameHeb;
  const projectId = projectConfigState.projectId;

  const generateTag = useTags();
  const portalHeaderTitleTag = generateTag(footerLang, "portal-header-title-tag");

  return (
    <header className={style.header}>

      <div className={style.cityLogoDiv}>
        <img
          onClick={() => navigateTo(`/home/${projectId}`)}
          className={style.cityLogo}
          src={projectConfigState.cityLogUrl} />
      </div>

      <div className={style.headerTitleDiv}>

        <span className={style.headerTitle} onClick={() => navigateTo(`/home/${projectId}`)}
        >
          {portalHeaderTitleTag}
          <span className={style.lolaPortal}> {cityName} </span>
        </span>

      </div>

      <div className={style.languageDiv}>
        <LanguageSelect />
      </div>

    </header>
  );

  function navigateTo(path: string) {
    navigate(path);
  }
}

export default Header;